export enum AssetManagersUserEvents {
    TableLinkClick = "Asset Managers Table - Click Individual Page Link",
    TableLinkClickPlatform = "Asset Managers Table - Click Platform Link",
    TableLinkClickNetwork = "Asset Managers Table - Click Network Link",
    ClickAssetClassLink = "Asset Managers Table - Click Asset Class Link",
    ClickManagerIndividualWebsite = "Asset Managers Individual Header - Click Website",
}
